import React, { useState, useEffect } from "react";
import brand from "../../assets/brand.png";
export function HomeScreenLoader() {
  const [progress, setProgress] = useState(0);
  const [currentModule, setCurrentModule] = useState("");

  const modules = [
    "Student Records",
    "Course Management",
    "Attendance Tracking",
    "Grade Book",
    "Schedule Planner",
    "Communication Portal",
    "Resource Library",
    "Analytics Dashboard",
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prevProgress) => {
        if (prevProgress >= 100) {
          clearInterval(interval);
          return 100;
        }
        return prevProgress + 1;
      });
    }, 50);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    setCurrentModule(modules[Math.floor((progress / 100) * modules.length)]);
  }, [progress]);

  const floatAnimation = {
    animation: "float 3s ease-in-out infinite",
  };

  return (
    <div
      style={{
        display: "flex",
        overflow: "hidden",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        backgroundColor: "var(--loaderscreenback-color)",
        padding: "2rem",
        textAlign: "center", // Ensuring text is centered
      }}
    >
      {/* Circular Loader Container */}
      <div
        style={{
          width: "clamp(220px, 30vw, 320px)",
          height: "clamp(220px, 30vw, 320px)",
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {/* Circular Loader */}
        <div
          style={{
            position: "absolute",
            width: "clamp(180px, 25vw, 260px)",
            height: "clamp(180px, 25vw, 260px)",
            borderRadius: "50%",
            border: "6px solid var(--loaderscreenwhite-color)",
            borderTopColor: "var(--loaderscreentext-color)",
            animation: "spin 2s linear infinite",
          }}
        ></div>
        {/* Logo */}
        <div
          style={{
            position: "absolute",
            width: "clamp(120px, 20vw, 160px)",
            height: "clamp(120px, 20vw, 160px)",
            borderRadius: "50%",
            backgroundColor: "var(--loaderscreenwhite-color)",
            boxShadow: "0 0 40px rgba(30, 64, 175, 0.7)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1,
          }}
        >
          <img
            src={brand}
            alt="Gyansansaar Logo"
            style={{
              width: "clamp(100px, 12vw, 120px)",
              height: "clamp(100px, 12vw, 120px)",
              objectFit: "contain",
              filter: "drop-shadow(0 0 20px rgba(255, 255, 255, 0.6))",
              ...floatAnimation,
            }}
          />
        </div>
      </div>

      {/* Text Section */}
      <div
        style={{
          marginTop: "2rem",
          width: "clamp(210px, 80%, 320px)", // Fixed width for consistent layout
        }}
      >
        {/* <h1
          style={{
            fontSize: "clamp(20px, 4vw, 30px)",
            fontWeight: "700",
            color: "#1e3a8a",
            marginBottom: "0.5rem",
          }}
        >
          Gyansansaar
        </h1> */}
        <p
          style={{
            fontSize: "clamp(17px, 4vw, 25px)",
            color: "var(--loaderscreenwhite-color)",
            marginBottom: "1.5rem",
            fontWeight: "500",
          }}
        >
          Initializing <strong style={{
            color: "var(--loaderscreentext-color)",
          }}>{currentModule}</strong>
        </p>
        {/* Progress Bar */}
        <div
          style={{
            width: "100%", // Ensure it stretches across the available space
            height: "10px",
            backgroundColor: "#e5e7eb",
            borderRadius: "9999px",
            overflow: "hidden",
            marginTop: "1rem", // Add a small gap
            display: "flex", // Ensure flex display for centering
            justifyContent: "center", // Center the progress bar
          }}
        >
          <div
            style={{
              height: "100%",
              width: `${progress}%`,
              background: "linear-gradient(90deg, var(--loaderscreentext-color), var(--loaderscreentext-color))",
              transition: "width 0.5s ease-out",
              borderRadius: "9999px",
            }}
          ></div>
        </div>
        <p
          style={{
            marginTop: "0.75rem",
            fontSize: "clamp(20px, 4vw, 30px)",
            color: "var(--loaderscreenwhite-color)",
            fontWeight: "600",
          }}
        >
          {progress}% Complete
        </p>
      </div>

      <style>
        {`
          @keyframes spin {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(360deg);
            }
          }
          @keyframes float {
            0% {
              transform: translateY(0px);
            }
            50% {
              transform: translateY(-10px);
            }
            100% {
              transform: translateY(0px);
            }
          }
        `}
      </style>
    </div>
  );
}